import React from 'react';
import ReactDOM from 'react-dom';
import '../App.css';

export default function Courses() {
    return (
        <div className="coursesSection" id="courses">
            <div className="coursesContainer">
                <div className="coursesTitling">
                    <p className="coursesTitle">COURSES TAKEN</p>
                    <p id="coursesDescriptText">All relevant computer science and engineering courses taken at California State University Fullerton and via publically accessible course programs such as those provided by Udemy.</p>
                </div>
                <div className="atlas">
                    <p className="atlasText" id="C">C - Completed</p>
                    <p className="atlasText" id="IP">IP - In Progress</p>
                    {/* <p className="atlasText" id="CR">CR - COVID-19 Credit</p> */}
                </div>
                <div className="coursesBlock">
                    {/* <div className="LPC-container">
                        <p className="schoolTitle">Las Positas College</p>
                        <br/>
                        <div className="courseBlock">
                            <p id="C">C&nbsp;&nbsp;</p>
                            <p className="courseName">MATH 1 - Calculus I</p>
                        </div>
                        <div className="courseBlock">
                            <p id="C">C&nbsp;&nbsp;</p>
                            <p className="courseName">MATH 2 - Calculus II</p>
                        </div>
                        <div className="courseBlock">
                            <p id="CR">CR&nbsp;&nbsp;</p>
                            <p className="courseName">MATH 10 - Discrete Mathematics</p>
                        </div>
                        <div className="courseBlock">
                            <p id="C">C&nbsp;&nbsp;</p>
                            <p className="courseName">MATH 40 - Elementary Statistics</p>
                        </div>
                        <div className="courseBlock">
                            <p id="CR">CR&nbsp;&nbsp;</p>
                            <p className="courseName">PHYS 1A - Newtonian Mechanics</p>
                        </div>
                        <div className="courseBlock">
                            <p>-</p>
                        </div> 
                        <div className="courseBlock">
                            <p id="C">C&nbsp;&nbsp;</p>
                            <p className="courseName">CS 1 - Computing Fundamentals I</p>
                        </div>
                        <div className="courseBlock">
                            <p id="C">C&nbsp;&nbsp;</p>
                            <p className="courseName">CS 2 - Computing Fundamentals II</p>
                        </div>
                        <div className="courseBlock">
                            <p id="C">C&nbsp;&nbsp;</p>
                            <p className="courseName">CS 20 - Data Structures & Algorithms</p>
                        </div>
                        <div className="courseBlock">
                            <p id="C">C&nbsp;&nbsp;</p>
                            <p className="courseName">CNT 51 - CompTIA's A+ IT Essentials</p>
                        </div>
                    </div> */}
                    <br/>
                    <div className="CSUF-container">
                        <p className="schoolTitle">California State University, Fullerton</p>
                        <br/>
                        {/* <div className="courseBlock">
                            <p id="C">C&nbsp;&nbsp;</p>
                            <p className="courseName">MATH 270B - Intro to Linear Algebra</p>
                        </div>
                        <div className="courseBlock">
                            <p id="C">C&nbsp;&nbsp;</p>
                            <p className="courseName">MATH 338 - Statistics Applied to Natural Sciences</p>
                        </div>
                        <div className="courseBlock">
                            <p>-</p>
                        </div>  */}
                        {/* <div className="courseBlock">
                            <p id="C">C&nbsp;&nbsp;</p>
                            <p className="courseName">CPSC 223N - Visual C# Programming</p>
                        </div> */}
                        <div className="courseBlock">
                            <p id="C">C&nbsp;&nbsp;</p>
                            <p className="courseName">CPSC 240 - Computer Organization</p>
                        </div>
                        {/* <div className="courseBlock">
                            <p id="C">C&nbsp;&nbsp;</p>
                            <p className="courseName">CPSC 315 - Professional Ethics in Computing</p>
                        </div> */}
                        <div className="courseBlock">
                            <p id="C">C&nbsp;&nbsp;</p>
                            <p className="courseName">CPSC 323 - Compilers, Languages & Automa Theory</p>
                        </div>
                        {/* <div className="courseBlock">
                            <p id="C">C&nbsp;&nbsp;</p>
                            <p className="courseName">CPSC 332 - Files Structures & Database Systems</p>
                        </div> */}
                        <div className="courseBlock">
                            <p id="C">C&nbsp;&nbsp;</p>
                            <p className="courseName">CPSC 335 - Algorithm Design & Analysis</p>
                        </div>
                        <div className="courseBlock">
                            <p id="C">C&nbsp;&nbsp;</p>
                            <p className="courseName">CPSC 351 - Operating System Concepts</p>
                        </div>
                        {/* <div className="courseBlock">
                            <p id="C">C&nbsp;&nbsp;</p>
                            <p className="courseName">CPSC 353 - Intro to Computer Security</p>
                        </div> */}
                        {/* <div className="courseBlock">
                            <p id="C">C&nbsp;&nbsp;</p>
                            <p className="courseName">CPSC 362 - Intro to Software Engineering</p>
                        </div> */}
                        <div className="courseBlock">
                            <p id="C">C&nbsp;&nbsp;</p>
                            <p className="courseName">CPSC 440 - Computer System Architecture</p>
                        </div>
                        <div className="courseBlock">
                            <p id="C">C&nbsp;&nbsp;</p>
                            <p className="courseName">CPSC 449 - Web Back-End Engineering</p>
                        </div>
                        {/* <div className="courseBlock">
                            <p id="C">C&nbsp;&nbsp;</p>
                            <p className="courseName">CPSC 459 - Blockchain Technologies</p>
                        </div> */}
                        <div className="courseBlock">
                            <p id="C">C&nbsp;&nbsp;</p>
                            <p className="courseName">CPSC 471 - Computer Communications & Networking</p>
                        </div>
                        <div className="courseBlock">
                            <p id="C">C&nbsp;&nbsp;</p>
                            <p className="courseName">CPSC 479 - Intro to High Performance Computing</p>
                        </div>
                        <div className="courseBlock">
                            <p id="C">C&nbsp;&nbsp;</p>
                            <p className="courseName">CPSC 481 - Artificial Intelligence</p>
                        </div>
                        <div className="courseBlock">
                            <p id="C">C&nbsp;&nbsp;</p>
                            <p className="courseName">CPSC 487 - Computational Epidemiology</p>
                        </div>
                        {/* <div className="courseBlock">
                            <p id="C">C&nbsp;&nbsp;</p>
                            <p className="courseName">CPSC 490 - Undergrad Seminar in Computer Science</p>
                        </div>
                        <div className="courseBlock">
                            <p id="C">C&nbsp;&nbsp;</p>
                            <p className="courseName">CPSC 491 - Senior Capstone Project in Computer Science</p>
                        </div> */}
                    </div>
                    <br/>
                    <div className="coursesBlock">
                        <div className="Self-container">
                            <p className="schoolTitle">Udemy & LinkedIn Learning Courses</p>
                            <br/>
                            <div className="courseBlock">
                                <p id="C">C&nbsp;&nbsp;</p>
                                <p className="courseName">Electronics Foundations: Fundamentals</p>
                            </div>
                            <div className="courseBlock">
                                <p id="IP">IP&nbsp;&nbsp;</p>
                                <p className="courseName">Learn FPGA Design with VHDL</p>
                            </div>
                            <div className="courseBlock">
                                <p id="IP">IP&nbsp;&nbsp;</p>
                                <p className="courseName">Complete Electronics Course 2022: Analog Hardware Design</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}